/** Types of contact communcation methods available. */
const COMMUNICATION_TYPES = ['phone', 'email', 'facebook', 'website']
const COMMUNICATION_SUBTYPES = ['home', 'cell', 'fax', 'work']

/** Types of contact income sources methods available. */
const INCOME_SOURCES = ['wages', 'investments', 'rental homes', 'other']

/** Types of contact income sources methods available. */
const ADDRESS_TYPES = [{ id: 1, type: 'Billing' }, { id: 2, type: 'Home' }, { id: 3, type: 'Mailing' }, { id: 4, type: 'Work' }]

/** Types of contact income sources methods available. */
const ADDRESS_OWNERSHIP = ['rent', 'own', 'other']

const IDENTIFICATION_TYPES = [
    { id: 1, type: "Driver License/ID Card", code: 1 },
    { id: 2, type: "Passport", code: 2 },
    { id: 3, type: "US Military", code: 3 },
    { id: 4, type: "US Immigration / Department of Justice", code: 4 },
    { id: 5, type: "Department of State", code: 5 },
    { id: 6, type: "Department of Homeland Security", code: 6 },
    { id: 7, type: "FEIN/EIN", code: 7 },
    { id: 8, type: "TID Number", code: 8 },
    { id: 9, type: "NATO ID", code: 9 },
    { id: 10, type: "Other Military Status of Forces ID", code: 10 },
    { id: 11, type: "License to Carry a Handgun", code: 11 },
]

/** Contact identification issuers (states) available. */
const ISSUERS = [
    {
        "name": "Alabama",
        "abbreviation": "AL"
    },
    {
        "name": "Alaska",
        "abbreviation": "AK"
    },
    {
        "name": "American Samoa",
        "abbreviation": "AS"
    },
    {
        "name": "Arizona",
        "abbreviation": "AZ"
    },
    {
        "name": "Arkansas",
        "abbreviation": "AR"
    },
    {
        "name": "California",
        "abbreviation": "CA"
    },
    {
        "name": "Colorado",
        "abbreviation": "CO"
    },
    {
        "name": "Connecticut",
        "abbreviation": "CT"
    },
    {
        "name": "Delaware",
        "abbreviation": "DE"
    },
    {
        "name": "District Of Columbia",
        "abbreviation": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM"
    },
    {
        "name": "Florida",
        "abbreviation": "FL"
    },
    {
        "name": "Georgia",
        "abbreviation": "GA"
    },
    {
        "name": "Guam",
        "abbreviation": "GU"
    },
    {
        "name": "Hawaii",
        "abbreviation": "HI"
    },
    {
        "name": "Idaho",
        "abbreviation": "ID"
    },
    {
        "name": "Illinois",
        "abbreviation": "IL"
    },
    {
        "name": "Indiana",
        "abbreviation": "IN"
    },
    {
        "name": "Iowa",
        "abbreviation": "IA"
    },
    {
        "name": "Kansas",
        "abbreviation": "KS"
    },
    {
        "name": "Kentucky",
        "abbreviation": "KY"
    },
    {
        "name": "Louisiana",
        "abbreviation": "LA"
    },
    {
        "name": "Maine",
        "abbreviation": "ME"
    },
    {
        "name": "Marshall Islands",
        "abbreviation": "MH"
    },
    {
        "name": "Maryland",
        "abbreviation": "MD"
    },
    {
        "name": "Massachusetts",
        "abbreviation": "MA"
    },
    {
        "name": "Michigan",
        "abbreviation": "MI"
    },
    {
        "name": "Minnesota",
        "abbreviation": "MN"
    },
    {
        "name": "Mississippi",
        "abbreviation": "MS"
    },
    {
        "name": "Missouri",
        "abbreviation": "MO"
    },
    {
        "name": "Montana",
        "abbreviation": "MT"
    },
    {
        "name": "Nebraska",
        "abbreviation": "NE"
    },
    {
        "name": "Nevada",
        "abbreviation": "NV"
    },
    {
        "name": "New Hampshire",
        "abbreviation": "NH"
    },
    {
        "name": "New Jersey",
        "abbreviation": "NJ"
    },
    {
        "name": "New Mexico",
        "abbreviation": "NM"
    },
    {
        "name": "New York",
        "abbreviation": "NY"
    },
    {
        "name": "North Carolina",
        "abbreviation": "NC"
    },
    {
        "name": "North Dakota",
        "abbreviation": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP"
    },
    {
        "name": "Ohio",
        "abbreviation": "OH"
    },
    {
        "name": "Oklahoma",
        "abbreviation": "OK"
    },
    {
        "name": "Oregon",
        "abbreviation": "OR"
    },
    {
        "name": "Palau",
        "abbreviation": "PW"
    },
    {
        "name": "Pennsylvania",
        "abbreviation": "PA"
    },
    {
        "name": "Puerto Rico",
        "abbreviation": "PR"
    },
    {
        "name": "Rhode Island",
        "abbreviation": "RI"
    },
    {
        "name": "South Carolina",
        "abbreviation": "SC"
    },
    {
        "name": "South Dakota",
        "abbreviation": "SD"
    },
    {
        "name": "Tennessee",
        "abbreviation": "TN"
    },
    {
        "name": "Texas",
        "abbreviation": "TX"
    },
    {
        "name": "Utah",
        "abbreviation": "UT"
    },
    {
        "name": "Vermont",
        "abbreviation": "VT"
    },
    {
        "name": "Virgin Islands",
        "abbreviation": "VI"
    },
    {
        "name": "Virginia",
        "abbreviation": "VA"
    },
    {
        "name": "Washington",
        "abbreviation": "WA"
    },
    {
        "name": "West Virginia",
        "abbreviation": "WV"
    },
    {
        "name": "Wisconsin",
        "abbreviation": "WI"
    },
    {
        "name": "Wyoming",
        "abbreviation": "WY"
    },
    { name: "Afghanistan", "abbreviation": "AFG" },
    { name: "Albania", "abbreviation": "ALB" },
    { name: "Algeria", "abbreviation": "ALG" },
    { name: "Andorra", "abbreviation": "AND" },
    { name: "Angola", "abbreviation": "ANG" },
    { name: "Antigua & Barbuda", "abbreviation": "ANT" },
    { name: "Argentina", "abbreviation": "ARG" },
    { name: "Armenia", "abbreviation": "ARM" },
    { name: "Australia", "abbreviation": "AUL" },
    { name: "Austria", "abbreviation": "AUS" },
    { name: "Azerbaijan", "abbreviation": "AZE" },
    { name: "Bahamas", "abbreviation": "BAH" },
    { name: "Bahrain", "abbreviation": "BHR" },
    { name: "Bangladesh", "abbreviation": "BAN" },
    { name: "Barbados", "abbreviation": "BAR" },
    { name: "Belarus", "abbreviation": "BEL" },
    { name: "Belgium", "abbreviation": "BEG" },
    { name: "Belize", "abbreviation": "BEZ" },
    { name: "Benin", "abbreviation": "BEN" },
    { name: "Bhutan", "abbreviation": "BHU" },
    { name: "Bolivia", "abbreviation": "BOL" },
    { name: "Bosnia & Herzegovina", "abbreviation": "BOS" },
    { name: "Botswana", "abbreviation": "BOT" },
    { name: "Brazil", "abbreviation": "BRA" },
    { name: "Brunei", "abbreviation": "BRU" },
    { name: "Bulgaria", "abbreviation": "BUL" },
    { name: "Burkina Faso", "abbreviation": "BKF" },
    { name: "Burundi", "abbreviation": "BUR" },
    { name: "Cabo Verde", "abbreviation": "CBV" },
    { name: "Cambodia", "abbreviation": "CAB" },
    { name: "Cameroon", "abbreviation": "CAM" },
    { name: "Canada", "abbreviation": "CAN" },
    { name: "Central African Republic", "abbreviation": "CEN" },
    { name: "Chad", "abbreviation": "CHA" },
    { name: "Chile", "abbreviation": "CHI" },
    { name: "China", "abbreviation": "CHN" },
    { name: "Colombia", "abbreviation": "COL" },
    { name: "Comoros", "abbreviation": "COM" },
    { name: "Congo", "abbreviation": "CON" },
    { name: "Costa Rica", "abbreviation": "COS" },
    { name: "Côte d'Ivoire", "abbreviation": "CÔT" },
    { name: "Croatia", "abbreviation": "CRO" },
    { name: "Cuba", "abbreviation": "CUB" },
    { name: "Cyprus", "abbreviation": "CYP" },
    { name: "Czech Republic", "abbreviation": "CZE" },
    { name: "Denmark", "abbreviation": "DEN" },
    { name: "Djibouti", "abbreviation": "DJI" },
    { name: "Dominica", "abbreviation": "DOM" },
    { name: "Dominican Republic", "abbreviation": "DMR" },
    { name: "DR Congo", "abbreviation": "DR " },
    { name: "Ecuador", "abbreviation": "ECU" },
    { name: "Egypt", "abbreviation": "EGY" },
    { name: "El Salvador", "abbreviation": "EL " },
    { name: "Equatorial Guinea", "abbreviation": "EQU" },
    { name: "Eritrea", "abbreviation": "ERI" },
    { name: "Estonia", "abbreviation": "EST" },
    { name: "Eswatini", "abbreviation": "ESW" },
    { name: "Ethiopia", "abbreviation": "ETH" },
    { name: "Fiji", "abbreviation": "FIJ" },
    { name: "Finland", "abbreviation": "FIN" },
    { name: "France", "abbreviation": "FRA" },
    { name: "Gabon", "abbreviation": "GAB" },
    { name: "Gambia", "abbreviation": "GAM" },
    { name: "Georgia", "abbreviation": "GEO" },
    { name: "Germany", "abbreviation": "GER" },
    { name: "Ghana", "abbreviation": "GHA" },
    { name: "Greece", "abbreviation": "GRE" },
    { name: "Grenada", "abbreviation": "GRN" },
    { name: "Guatemala", "abbreviation": "GUA" },
    { name: "Guinea", "abbreviation": "GUI" },
    { name: "Guinea-Bissau", "abbreviation": "GUB" },
    { name: "Guyana", "abbreviation": "GUY" },
    { name: "Haiti", "abbreviation": "HAI" },
    { name: "Holy See", "abbreviation": "HOL" },
    { name: "Honduras", "abbreviation": "HON" },
    { name: "Hungary", "abbreviation": "HUN" },
    { name: "Iceland", "abbreviation": "ICE" },
    { name: "India", "abbreviation": "IND" },
    { name: "Indonesia", "abbreviation": "INN" },
    { name: "Iran", "abbreviation": "IRA" },
    { name: "Iraq", "abbreviation": "IRQ" },
    { name: "Ireland", "abbreviation": "IRE" },
    { name: "Israel", "abbreviation": "ISR" },
    { name: "Italy", "abbreviation": "ITA" },
    { name: "Jamaica", "abbreviation": "JAM" },
    { name: "Japan", "abbreviation": "JAP" },
    { name: "Jordan", "abbreviation": "JOR" },
    { name: "Kazakhstan", "abbreviation": "KAZ" },
    { name: "Kenya", "abbreviation": "KEN" },
    { name: "Kiribati", "abbreviation": "KIR" },
    { name: "Kuwait", "abbreviation": "KUW" },
    { name: "Kyrgyzstan", "abbreviation": "KYR" },
    { name: "Laos", "abbreviation": "LAO" },
    { name: "Latvia", "abbreviation": "LAT" },
    { name: "Lebanon", "abbreviation": "LEB" },
    { name: "Lesotho", "abbreviation": "LES" },
    { name: "Liberia", "abbreviation": "LIR" },
    { name: "Libya", "abbreviation": "LIB" },
    { name: "Liechtenstein", "abbreviation": "LIE" },
    { name: "Lithuania", "abbreviation": "LIT" },
    { name: "Luxembourg", "abbreviation": "LUX" },
    { name: "Madagascar", "abbreviation": "MAD" },
    { name: "Malawi", "abbreviation": "MAW" },
    { name: "Malaysia", "abbreviation": "MLY" },
    { name: "Maldives", "abbreviation": "MLD" },
    { name: "Mali", "abbreviation": "MAL" },
    { name: "Malta", "abbreviation": "MAT" },
    { name: "Marshall Islands", "abbreviation": "MAI" },
    { name: "Mauritania", "abbreviation": "MAR" },
    { name: "Mauritius", "abbreviation": "MAU" },
    { name: "Mexico", "abbreviation": "MEX" },
    { name: "Micronesia", "abbreviation": "MIC" },
    { name: "Moldova", "abbreviation": "MOL" },
    { name: "Monaco", "abbreviation": "MON" },
    { name: "Mongolia", "abbreviation": "MNG" },
    { name: "Montenegro", "abbreviation": "MNT" },
    { name: "Morocco", "abbreviation": "MOR" },
    { name: "Mozambique", "abbreviation": "MOZ" },
    { name: "Myanmar", "abbreviation": "MYA" },
    { name: "Namibia", "abbreviation": "NAM" },
    { name: "Nauru", "abbreviation": "NAU" },
    { name: "Nepal", "abbreviation": "NEP" },
    { name: "Netherlands", "abbreviation": "NET" },
    { name: "New Zealand", "abbreviation": "NEW" },
    { name: "Nicaragua", "abbreviation": "NIC" },
    { name: "Niger", "abbreviation": "NIG" },
    { name: "Nigeria", "abbreviation": "NGR" },
    { name: "North Korea", "abbreviation": "NKO" },
    { name: "North Macedonia", "abbreviation": "NMA" },
    { name: "Norway", "abbreviation": "NOR" },
    { name: "Oman", "abbreviation": "OMA" },
    { name: "Pakistan", "abbreviation": "PAK" },
    { name: "Palau", "abbreviation": "PAL" },
    { name: "Panama", "abbreviation": "PAN" },
    { name: "Papua New Guinea", "abbreviation": "PAP" },
    { name: "Paraguay", "abbreviation": "PAR" },
    { name: "Peru", "abbreviation": "PER" },
    { name: "Philippines", "abbreviation": "PHI" },
    { name: "Poland", "abbreviation": "POL" },
    { name: "Portugal", "abbreviation": "POR" },
    { name: "Qatar", "abbreviation": "QAT" },
    { name: "Romania", "abbreviation": "ROM" },
    { name: "Russia", "abbreviation": "RUS" },
    { name: "Rwanda", "abbreviation": "RWA" },
    { name: "Saint Kitts & Nevis", "abbreviation": "SKN" },
    { name: "Saint Lucia", "abbreviation": "SLU" },
    { name: "Samoa", "abbreviation": "SAM" },
    { name: "San Marino", "abbreviation": "SAN" },
    { name: "Sao Tome & Principe", "abbreviation": "SAO" },
    { name: "Saudi Arabia", "abbreviation": "SAU" },
    { name: "Senegal", "abbreviation": "SEN" },
    { name: "Serbia", "abbreviation": "SER" },
    { name: "Seychelles", "abbreviation": "SEY" },
    { name: "Sierra Leone", "abbreviation": "SIE" },
    { name: "Singapore", "abbreviation": "SIN" },
    { name: "Slovakia", "abbreviation": "SVK" },
    { name: "Slovenia", "abbreviation": "SLK" },
    { name: "Solomon Islands", "abbreviation": "SOL" },
    { name: "Somalia", "abbreviation": "SOM" },
    { name: "South Africa", "abbreviation": "SAF" },
    { name: "South Korea", "abbreviation": "SKO" },
    { name: "South Sudan", "abbreviation": "SOU" },
    { name: "Spain", "abbreviation": "SPA" },
    { name: "Sri Lanka", "abbreviation": "SRI" },
    { name: "St. Vincent & Grenadines", "abbreviation": "ST." },
    { name: "State of Palestine", "abbreviation": "STA" },
    { name: "Sudan", "abbreviation": "SUD" },
    { name: "Suriname", "abbreviation": "SUR" },
    { name: "Sweden", "abbreviation": "SWE" },
    { name: "Switzerland", "abbreviation": "SWI" },
    { name: "Syria", "abbreviation": "SYR" },
    { name: "Tajikistan", "abbreviation": "TAJ" },
    { name: "Tanzania", "abbreviation": "TAN" },
    { name: "Thailand", "abbreviation": "THA" },
    { name: "Timor-Leste", "abbreviation": "TIM" },
    { name: "Togo", "abbreviation": "TOG" },
    { name: "Tonga", "abbreviation": "TON" },
    { name: "Trinidad & Tobago", "abbreviation": "TRI" },
    { name: "Tunisia", "abbreviation": "TUN" },
    { name: "Turkey", "abbreviation": "TUR" },
    { name: "Turkmenistan", "abbreviation": "TRK" },
    { name: "Tuvalu", "abbreviation": "TUV" },
    { name: "Uganda", "abbreviation": "UGA" },
    { name: "Ukraine", "abbreviation": "UKR" },
    { name: "United Arab Emirates", "abbreviation": "UAE" },
    { name: "United Kingdom", "abbreviation": "UNK" },
    { name: "United States", "abbreviation": "USA" },
    { name: "Uruguay", "abbreviation": "URU" },
    { name: "Uzbekistan", "abbreviation": "UZB" },
    { name: "Vanuatu", "abbreviation": "VAN" },
    { name: "Venezuela", "abbreviation": "VEN" },
    { name: "Vietnam", "abbreviation": "VIE" },
    { name: "Yemen", "abbreviation": "YEM" },
    { name: "Zambia", "abbreviation": "ZAM" },
    { name: "Zimbabwe", "abbreviation": "ZIM" }
]

const PROVIDER_TYPES = [
    { name: 'Service' },
    { name: 'Vehicle' },
    { name: 'Product' },
    { name: 'GPS' }
]
const FINANCE_TYPES = [
    { name: 'Non-Related' },
    { name: 'Related' }
]
const RELATIONSHIP_TYPES = [
    {
        id: 1,
        type: "Family",
        relation: "Father",
    },
    {
        id: 2,
        type: "Family",
        relation: "Mother",
    },
    {
        id: 3,
        type: "Family",
        relation: "Sister",
    },
    {
        id: 4,
        type: "Family",
        relation: "Brother",
    },
    {
        id: 5,
        type: "Family",
        relation: "Cousin",
    },
    {
        id: 6,
        type: "Family",
        relation: "Aunt",
    },
    {
        id: 7,
        type: "Family",
        relation: "Uncle",
    },
    {
        id: 8,
        type: "Family",
        relation: "Grand Mother",
    },
    {
        id: 9,
        type: "Family",
        relation: "Grand Father",
    },
    {
        id: 10,
        type: "Family",
        relation: "Son",
    },
    {
        id: 11,
        type: "Family",
        relation: "Daughter",
    },
    {
        id: 12,
        type: "Family",
        relation: "Spouse",
    },
    {
        id: 13,
        type: "Family",
        relation: "Other",
    },
    {
        id: 14,
        type: "Friend",
        relation: "Friend",
    },
    {
        id: 15,
        type: "Resident",
        relation: "Landlord",
    },
    {
        id: 16,
        type: "Work",
        relation: "Employer",
    },
    {
        id: 17,
        type: "Work",
        relation: "Employee",
    },
    {
        id: 20,
        type: "Work",
        relation: "Business Contact",
    },
    {
        id: 18,
        type: "Lender",
        relation: "Lender",
    },
    {
        id: 19,
        type: "Other",
        relation: "Other",
    }
];

const FINANCING_OPTIONS = [
    { id: 3, name: "Outside Finance" },
    { id: 4, name: "BHPH" },
]

const BUYING_CRITERIA = [
    { name: "Current Balance" },
    { name: "Current Payoff" },
    { name: "Principal + Tax" },
]

module.exports = {
    COMMUNICATION_TYPES,
    COMMUNICATION_SUBTYPES,
    IDENTIFICATION_TYPES,
    ISSUERS,
    INCOME_SOURCES,
    ADDRESS_TYPES,
    ADDRESS_OWNERSHIP,
    PROVIDER_TYPES,
    FINANCE_TYPES,
    RELATIONSHIP_TYPES,
    FINANCING_OPTIONS,
    BUYING_CRITERIA
}